import TR from 'utils/TR';
import useNavAction from 'hooks/actions/useNavAction';
import T from 'utils/T';
import ex from 'utils/ex';
import FocusableButton from 'components/common/FocusableButton';
import React from 'react';
import HBox from 'components/common/HBox';
import SimulationDietTabs from './SimulationDietTabs';

export default function SimulationTabs(props) {
  const {
    children,
    ...rest
  } = props;

  const {
    triggered: triggeredSimulationExercise,
    onTrigger: onTriggerSimulationExercise,
  } = useNavAction({ name: 'SimulationExercise' }, props);

  const {
    triggered: triggeredSimulationDiet,
    onTrigger: onTriggerSimulationDiet,
  } = useNavAction({ name: 'SimulationDiet' }, props);

  const {
    triggered: triggeredSimulationInsulin,
    onTrigger: onTriggerSimulationInsulin,
  } = useNavAction({ name: 'SimulationInsulin' }, props);


  return (
    <HBox between {...ex('SimulationTabs', rest)}>
      <HBox>
        <FocusableButton
          {...ex(['SimulationButton', { triggered: triggeredSimulationExercise }], {
            disabled: triggeredSimulationExercise,
            onClick: onTriggerSimulationExercise(),
          })}
        >
          {T('활동')}
        </FocusableButton>
        <FocusableButton
          {...ex(['SimulationButton', { triggered: triggeredSimulationDiet }], {
            disabled: triggeredSimulationDiet,
            onClick: onTriggerSimulationDiet(),
          })}
        >
          {T('식사')}
        </FocusableButton>
        <FocusableButton
          {...ex(['SimulationButton', { triggered: triggeredSimulationInsulin }], {
            disabled: triggeredSimulationInsulin,
            onClick: onTriggerSimulationInsulin(),
          })}
        >
          {T('인슐린')}
        </FocusableButton>
      </HBox>

      <HBox>
        {triggeredSimulationDiet && (
          <SimulationDietTabs {...{ category: 'SimulationDiet' }} />
        )}
      </HBox>
    </HBox>
  );
}
